module.exports = "pegasus/assets/lp/travel/bg1.png";